"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FlowFieldDetailsDialog = exports.DetailsName = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const data_structures_1 = require("@tableau/data-structures");
const vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const LabelsHookHelper_1 = require("../Labels/LabelsHookHelper");
const renderQueryResult_1 = require("../renderQueryResult");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const dialogWidth = 500;
const DetailsPane = (0, vizportalclient_common_components_1.divWithStyle)('DetailsPane', Object.assign(Object.assign({}, data_catalog_shared_1.vizPortalFontStyle), { fontSize: widgets_1.TabStyles.Typography.Sizing.Default }));
exports.DetailsName = (0, vizportalclient_common_components_1.divWithStyle)('DetailsName', {
    fontSize: widgets_1.TabStyles.Typography.Sizing.XLarge,
});
const DetailsProperties = (0, vizportalclient_common_components_1.divWithStyle)('DetailsProperties', {
    display: 'table',
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
const DetailsProperty = (0, vizportalclient_common_components_1.divWithStyle)('DetailsProperty', {
    display: 'table-row',
});
const DetailsLabel = (0, vizportalclient_common_components_1.divWithStyle)('DetailsLabel', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
    color: widgets_1.TabStyles.Typography.Color.Secondary,
    textAlign: 'right',
});
const DetailsValue = (0, vizportalclient_common_components_1.divWithStyle)('DetailsValue', {
    display: 'table-cell',
    padding: widgets_1.TabStyles.Spacing.DefaultSpace,
});
const DetailsPlaceholderMessage = (0, vizportalclient_common_components_1.divWithStyle)('DetailsPlaceholderMessage', {
    paddingTop: widgets_1.TabStyles.Spacing.DefaultSpace,
});
class FlowFieldDetailsDialog extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.renderFlowFieldDetailsDialog = (data) => {
            const flowOutputStep = data.flowOutputSteps && data.flowOutputSteps[0];
            if (!flowOutputStep) {
                return null;
            }
            const flowField = flowOutputStep.outputFields && flowOutputStep.outputFields[0];
            if (!flowField) {
                return null;
            }
            return (react_1.default.createElement(widgets_1.DialogWidget, { testId: 'flow-field-details', title: catalog_messages_1.Messages.FieldDetails(), type: widgets_1.DialogType.NormalWithTitleBar, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, dialogWidth: dialogWidth, showCloseButton: true, showFooter: false, isModal: true, onCloseRequest: this.props.onClose, handleGlassClick: this.props.onClose },
                react_1.default.createElement(DetailsPane, null,
                    react_1.default.createElement(exports.DetailsName, null, flowField.name),
                    react_1.default.createElement(LabelsHookHelper_1.LabelWrapper, { itemInfo: flowField, isEager: true, kind: 'chip', wrapper: (e) => (react_1.default.createElement("span", null,
                            react_1.default.createElement("span", { style: ColumnAndFieldDetailsStyles_1.flowFieldDetailsLabelsStyle }, e))) }),
                    this.renderProperties(flowField))));
        };
    }
    render() {
        return (react_1.default.createElement(components_1.Query, { query: catalog_queries_1.FlowFieldDetailsDocument, variables: { flowOutputStepId: this.props.flowOutputStepId, flowFieldId: this.props.flowFieldId } }, result => react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: { renderData: this.renderFlowFieldDetailsDialog } })));
    }
    renderProperties(flowField) {
        switch (flowField.__typename) {
            case 'FlowColumnOutputField':
                if (flowField.column) {
                    if (flowField.column.name !== null) {
                        const column = flowField.column;
                        const table = column.table;
                        // The table for a column should always be defined.
                        const tableId = table ? table.id : '';
                        const columnName = column.name !== null ? column.name : catalog_messages_1.Messages.PermissionsRequired();
                        return (react_1.default.createElement(DetailsProperties, null,
                            react_1.default.createElement(DetailsProperty, null,
                                react_1.default.createElement(DetailsLabel, null, catalog_messages_1.Messages.FlowFieldDetails_OutputsToColumn()),
                                react_1.default.createElement(DetailsValue, null,
                                    react_1.default.createElement(catalog_core_1.SiteUrlsContext.Consumer, null, urls => (react_1.default.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: urls.catalogTableColumnPath(tableId, column.id), title: columnName }, columnName)))))));
                    }
                    else {
                        return (react_1.default.createElement(DetailsPlaceholderMessage, null, catalog_messages_1.Messages.PermissionsRequired()));
                    }
                }
                else {
                    return (react_1.default.createElement(DetailsPlaceholderMessage, null, catalog_messages_1.Messages.FlowFieldDetails_OutputColumnUnavailable()));
                }
            case 'FlowFieldOutputField':
                if (flowField.field) {
                    if (flowField.field.name !== null) {
                        const field = flowField.field;
                        const datasource = field.datasource;
                        // The datasource for a flow output field should always be defined,
                        // if the field edge is, and it should always be a published data source,
                        // since flows can't output workbooks.
                        const datasourceVizportalUrlId = datasource && datasource.__typename === 'PublishedDatasource'
                            ? datasource.vizportalUrlId
                            : '';
                        const fieldName = field.name !== null ? field.name : catalog_messages_1.Messages.PermissionsRequired();
                        return (react_1.default.createElement(DetailsProperties, null,
                            react_1.default.createElement(DetailsProperty, null,
                                react_1.default.createElement(DetailsLabel, null, catalog_messages_1.Messages.FlowFieldDetails_OutputsToField()),
                                react_1.default.createElement(DetailsValue, null,
                                    react_1.default.createElement(catalog_core_1.SiteUrlsContext.Consumer, null, urls => (react_1.default.createElement(react_router_dom_1.Link, { className: data_catalog_shared_1.linkClass, to: urls.datasourceLineageFieldPath(datasourceVizportalUrlId, field.id), title: fieldName }, fieldName)))))));
                    }
                    else {
                        return (react_1.default.createElement(DetailsPlaceholderMessage, null, catalog_messages_1.Messages.PermissionsRequired()));
                    }
                }
                else {
                    return (react_1.default.createElement(DetailsPlaceholderMessage, null, catalog_messages_1.Messages.FlowFieldDetails_OutputFieldUnavailable()));
                }
            default:
                (0, data_structures_1.assertNever)(flowField);
                return null;
        }
    }
}
exports.FlowFieldDetailsDialog = FlowFieldDetailsDialog;
//# sourceMappingURL=FlowFieldDetailsDialog.js.map